export class BusinessSubscriptionDescriptionToDisplayViewModel {
    public culture: string;
    public description: string;

    constructor(culture: string, description: string) {
        this.culture = culture;
        this.description = description;
    }
}
